import * as React from 'react';

export const JobReqEvaluationTab = () => {
  return <div>TBA tab content: JobReqEvaluationTab</div>;
};
